import {FC} from 'react';
import Accordion from 'components/Accordion';
import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import Value from 'components/Value';
import {SupersendMessagePreview} from 'pages/History/SendingOrders/Details/types';
import {t} from 'ttag';

type SendViaSecureSendProps = {
    isSelected: boolean;
    messagePreview: SupersendMessagePreview;
    notificationRecipients?: string[];
    sendToContacts: string[];
};

const SendViaSecureSend: FC<SendViaSecureSendProps> = ({
    isSelected,
    messagePreview,
    notificationRecipients,
    sendToContacts,
}) => {
    if (!isSelected) return null;

    return (
        <Accordion
            header={
                <span className="flex gap-2 items-center">
                    {t`Secure Send`}
                    <TooltipIcon
                        href="https://www.makeleaps.com/en/q-a/what-is-secure-send/"
                        message={t`What is Secure Send?`}
                        size="base"
                    />
                </span>
            }
            id="send-via-securesend"
            isOpenByDefault={true}
        >
            <KeyValue keyWidth={10}>
                <Field
                    label={
                        <span className="flex items-center gap-2">
                            {t`Send to`}
                            <TooltipIcon
                                href="https://help.makeleaps.jp/ja/articles/4108456"
                                message={t`Who receives emails when securely sending documents?`}
                                size="base"
                            />
                        </span>
                    }
                    type="value"
                >
                    {sendToContacts ? (
                        <Value
                            value={{
                                type: 'tags',
                                value: sendToContacts,
                            }}
                        />
                    ) : (
                        <Value
                            value={{
                                type: 'string',
                                value: t`No Client Inbox Users set.`,
                            }}
                        />
                    )}
                </Field>
                {notificationRecipients && (
                    <Field
                        label={
                            <span className="flex items-center gap-2">
                                {t`Team Notification`}
                                <TooltipIcon
                                    href="https://help.makeleaps.jp/ja/articles/5746705"
                                    message={t`Who receives the account notifications related to the sending activities?`}
                                    size="base"
                                />
                            </span>
                        }
                        type="value"
                    >
                        <Value
                            value={{
                                type: 'tags',
                                value: notificationRecipients,
                            }}
                        />
                    </Field>
                )}
                <Field label={t`Subject`} type="value">
                    <Value
                        value={{
                            type: 'string',
                            value: messagePreview.subject,
                        }}
                    />
                </Field>
                <Field label={t`Message`} type="value">
                    <Value
                        value={{
                            type: 'string',
                            value: messagePreview.message,
                        }}
                    />
                </Field>
                {messagePreview.messageSuffix && (
                    <Field type="value">
                        <Value
                            className="whitespace-pre-line"
                            value={{
                                type: 'string',
                                value: messagePreview.messageSuffix,
                            }}
                        />
                    </Field>
                )}
            </KeyValue>
        </Accordion>
    );
};

export default SendViaSecureSend;
